import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, l = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M4 20.25h7.943a.75.75 0 0 1 0 1.5H4A1.75 1.75 0 0 1 2.25 20V4c0-.966.783-1.75 1.75-1.75h16c.966 0 1.75.782 1.75 1.75v9.009a.75.75 0 0 1-.87.741H3.75V20c0 .138.112.25.25.25Zm-.25-8v-4.5h7.5v4.5h-7.5Zm9 0h7.5v-4.5h-7.5v4.5ZM20.25 4v2.25H3.75V4A.25.25 0 0 1 4 3.75h16a.25.25 0 0 1 .25.25Z",
  "clip-rule": "evenodd"
}, null, -1), n = /* @__PURE__ */ e("path", { d: "M12.87 17.945a.76.76 0 0 0-.339.625.74.74 0 0 0 .329.623l4.776 3.188c.23.153.527.166.772.033a.76.76 0 0 0 .399-.667v-2.371h4.018a.76.76 0 0 0 .758-.75.74.74 0 0 0-.742-.75h-4.034v-2.497a.74.74 0 0 0-.394-.655.75.75 0 0 0-.767.04l-4.776 3.181Z" }, null, -1), h = [
  l,
  n
];
function d(a, r) {
  return t(), o("svg", c, [...h]);
}
const v = { render: d };
export {
  v as default,
  d as render
};
